import React from 'react';
import { TreeSelect, TreeSelectProps } from 'antd';
import { twMerge } from 'tailwind-merge';

interface Props {
  className?: string;
  classNameLabel?: string;
  classNameSelector?: string;
  required?: boolean;
  label?: string;
  error?: string;
  name?: string;
}

export function TreeSelector(props: Props & TreeSelectProps) {
  const { className, classNameLabel, label, classNameSelector, name, error, required, ...prop } =
    props;

  return (
    <div className={className}>
      {label && (
        <label
          htmlFor={name}
          className={twMerge('text-gray_800 text-sm mb-2 gap-1 flex', classNameLabel)}
        >
          {label}
          {required && <span className="text-error">*</span>}
        </label>
      )}
      <TreeSelect className={twMerge('w-full', classNameSelector)} {...prop} />
      {error && <span className="text-sm text-error">{error}</span>}
    </div>
  );
}
